import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import { Checkbox } from "@mui/material";
import { useEffect, useState } from "react";
import NumberFormat from "react-number-format";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { compose } from "underscore";
import { AlertInfo, CustomButton, DefaultLoader } from "../../components";
import { dataLayerGTM } from "../../utils/functions/dataLayerGTM";
import { setLastAmountInvest } from "../fundSelectionStep2/redux/actions";
import { getCustomer } from "../redux/action";
import {
  clearErrorInvestCheckout,
  clearInvestCheckoutLoading,
  investCheckout,
} from "./redux/actions";
import "./styles.scss";
import AccountVerificationPopup from "../../components/AccountVerificationPopup";

const riskDisclosure =
  "https://www.principal.com.my/en/ut-loan-financing-risk-my/mv";
const principalTnCPDF =
  "https://www.principal.com.my/sites/default/files/pdf-uploads/Principal%20Mini%20Program%20%28IMMF%20Class%20D%29%20Terms%20and%20Conditions.pdf";

function FundSelectionStep3(props) {
  let {
    fundsCode = [],
    totalFundsAmount,
    investAmount,
    investCheckout,
    clearInvestCheckoutLoading,
    investCheckoutLoading,
    history,
    investCheckoutError,
    showAccountVerificationError,
    clearErrorInvestCheckout,
    selectedPromo,
    custFundDetail,
    setLastAmountInvest,
    profile,
    getCustomer,
    loading,
  } = props;

  const [isCheck, setCheck] = useState(false);

  const { productId = "", cifPlanId = "" } = custFundDetail;

  useEffect(() => {
    clearInvestCheckoutLoading();
    getCustomer();
  }, []);

  useEffect(() => {
    if (Object.keys(selectedPromo).length === 0) {
      setLastAmountInvest();
    }
  }, [selectedPromo]);
  const getPromoPayload = () => {
    let promoPayload = "";
    if (Object.keys(selectedPromo).length === 0) {
      return promoPayload;
    }
    if (selectedPromo.selectedReferralCode) {
      promoPayload = selectedPromo.selectedReferralCode;
      return promoPayload;
    }
    if (Array.isArray(selectedPromo.eligibilityRules.codes)) {
      const getPromoPayload = selectedPromo.eligibilityRules.codes.filter(
        code => code.isPublic
      );
      if (Array.isArray(getPromoPayload) && getPromoPayload.length > 0) {
        promoPayload = getPromoPayload[0].code;
      }
    }
    return promoPayload;
  };

  const handleSubmit = () => {
    dataLayerGTM(
      "click_tag",
      "Click",
      "Button",
      "Fund Cash In Summary - Continue"
    );
    let promoCode = getPromoPayload();

    investCheckout({
      campaignCode: promoCode,
      cifPlanId,
      productId,
      funds: [
        {
          fundCd: fundsCode[0].code,
          amount: totalFundsAmount,
          amountCcy: "MYR",
        },
      ],
      customerChannelCode: "Mini Program",
      amount: totalFundsAmount.toString(),
      ccy: "MYR",
      cifId: profile.masterId,
      name: profile.fullName,
      email: profile && profile.email,
      source: "MiniProgram",
      sourceType: "CashIn",
    });
  };

  const handleNavigate = url => {
    window.my.navigateTo({
      url: "/pages/link/link?url=" + encodeURIComponent(url),
    });
  };

  const principalTnC = () => {
    window.my.showLoading();
    window.my.postMessage({
      api: "downloadFile",
      pdf: principalTnCPDF,
      event: "openPdf",
    });
  };

  if (investCheckoutLoading || loading) return <DefaultLoader />;

  return (
    <>
      <AlertInfo
        description="We are facing some technical issues, and we are working very hard to resolve the issue."
        isOpen={investCheckoutError && !showAccountVerificationError}
        isTimeout
        handleAction={() => {
          clearErrorInvestCheckout();
        }}
        testId="technical-issue"
      />
      <AccountVerificationPopup
        isOpen={investCheckoutError && showAccountVerificationError}
        onChat={clearErrorInvestCheckout}
        onClose={clearErrorInvestCheckout}
        title="Information Verification"
      />
      <div className="deposit-wrapper">
        <div className="back-btn-wrapper">
          <ArrowBackOutlinedIcon
            sx={{ fontSize: 24, color: "#0091da" }}
            onClick={() => {
              dataLayerGTM(
                "click_tag",
                "Click",
                "Button",
                "Fund Cash In Summary - back button"
              );
              history.back();
            }}
          />
          <h4 className="investment-summary">Your Investment Summary</h4>
        </div>
      </div>

      <div>
        {fundsCode.map((item, index) => (
          <div className="investment-summary-box" key={index}>
            <h2>{item.name}</h2>
            <div>
              <h4>
                <span>Cash In</span>
                <span>
                  RM
                  <NumberFormat
                    value={investAmount}
                    thousandSeparator
                    displayType="text"
                    decimalScale={2}
                    fixedDecimalScale={true}
                  />
                </span>
              </h4>
              <p
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "start",
                }}
              >
                <span>
                  Inclusive of Sales Charge
                  <br />
                  <span style={{ fontSize: "12px", fontWeight: 400 }}>
                    ({item.serviceTaxPerc || 0}% SST applicable on Sales Charge)
                  </span>
                </span>{" "}
                <span>{item.salesCharge || 0}%</span>
              </p>
              <h4>
                {Object.keys(selectedPromo).length > 0 && (
                  <>
                    <span>{selectedPromo.name}</span>
                    <span>-</span>{" "}
                  </>
                )}
              </h4>
            </div>
          </div>
        ))}
      </div>

      <div className="investment-summary-value-box">
        <p className="investment-summary-value-box__cahsin-label">
          Total Cash In
        </p>
        <p className="investment-summary-value-box__total-cashin">
          RM{" "}
          <NumberFormat
            value={totalFundsAmount}
            thousandSeparator
            displayType="text"
            decimalScale={2}
            fixedDecimalScale={true}
          />
        </p>
      </div>
      <div className="investment-summery-term">
        <Checkbox
          checked={isCheck}
          onChange={() => setCheck(!isCheck)}
          color="primary"
          sx={{
            margin: 0,
            padding: "0px !important",
            paddingTop: 0.5,
            "& .MuiSvgIcon-root": { fontSize: 24 },
          }}
          inputProps={{
            "data-cy": "invest-terms",
          }}
        />
        <div className="investment-summery-term__text">
          <p style={{ marginBottom: "8px" }}>
            I have read and agreed to{" "}
            <span onClick={principalTnC}>Principal’s Terms & Conditions</span>,
            the Unit Trust Loan Financing{" "}
            <span onClick={() => handleNavigate(riskDisclosure)}>
              Risk Disclosure Statement
            </span>
            , and have read and understood the relevant Prospectus, Information
            Memorandum and/or Disclosure Document including any supplemental
            thereof and the Product Highlight Sheet (if any) before Investing.
          </p>
          <p>
            I acknowledge the investment risk, and aware that the fund is not
            E-money, deposit, or capital guaranteed/protected by PIDM. Losses
            are not covered by the Capital Market Compensation Fund.
          </p>
        </div>
      </div>

      <div className="invest-summary-confirm">
        <CustomButton
          text="Cash In"
          variant="contained"
          color="#fff"
          backgroundColor="#1278CC"
          disabled={!isCheck || investCheckoutLoading}
          onClick={handleSubmit}
          testId="invest-cashin-btn"
        />
      </div>
    </>
  );
}

const withConnect = connect(
  state => ({
    loading: state.goal.loading,
    profile: state.goal.profile,
    ...state.riskAssessmentReducer,
    ...state.fundSelectionReducer,
    ...state.investPortfolioReducer,
    ...state.investCheckoutReducer,
    ...state.custFundDetailReducer,
    ...state.promoReducer,
    profile: state.goal.profile,
  }),
  {
    investCheckout,
    clearInvestCheckoutLoading,
    clearErrorInvestCheckout,
    setLastAmountInvest,
    getCustomer,
  }
);

export default compose(
  withRouter,
  withConnect
)(FundSelectionStep3);
